import React from "react";
import {
  Box,
  Typography,
  Avatar,
  Grid,
  Stack,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Circle } from "@mui/icons-material";

const Resume39 = ({ color = "#084c34" }) => {
  const accentColor = "#f4c05c"; // The yellow/gold from the design

  // Sidebar Section Title (White tab with asymmetrical rounding)
  const SidebarHeader = ({ title }) => (
    <Box
      sx={{
        bgcolor: "#fff",
        color: color,
        px: 2,
        py: 0.6,
        borderRadius: "15px 0 15px 0",
        display: "inline-block",
        mb: 2,
        mt: 4,
        width: "fit-content",
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{ fontWeight: 900, fontSize: "12px", letterSpacing: "1px" }}
      >
        {title}
      </Typography>
    </Box>
  );

  // Main Content Section Title (Dark tab with symmetrical rounding)
  const MainHeader = ({ title }) => (
    <Box
      sx={{
        bgcolor: color,
        color: "#fff",
        px: 2.5,
        py: 0.5,
        borderRadius: "20px",
        display: "inline-block",
        mb: 2,
        mt: 1,
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{ fontWeight: 700, fontSize: "12px", letterSpacing: "0.5px" }}
      >
        {title}
      </Typography>
    </Box>
  );

  return (
    <Box
      sx={{
        width: "210mm",
        minHeight: "297mm",
        mx: "auto",
        bgcolor: "#fff",
        boxShadow: "0 0 20px rgba(0,0,0,0.15)",
        display: "flex",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* LEFT SIDEBAR */}
      <Box
        sx={{
          width: "38%",
          bgcolor: color,
          color: "#fff",
          p: 4,
          pt: 6,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Profile Image with Gold Ring */}
        <Box
          sx={{
            width: 160,
            height: 160,
            border: `6px solid ${accentColor}`,
            borderRadius: "50%",
            mx: "auto",
            mb: 4,
            overflow: "hidden",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            bgcolor: "#fff"
          }}
        >
          <Avatar
            src="https://via.placeholder.com/200"
            sx={{ width: "100%", height: "100%" }}
          />
        </Box>

        {/* Contact */}
        <SidebarHeader title="CONTACT" />
        <Stack spacing={1.5} sx={{ pl: 1 }}>
          <Typography fontSize="11px">📞 +123-456-7890</Typography>
          <Typography fontSize="11px">📧 hello@reallygreatsite.com</Typography>
          <Typography fontSize="11px">🌐 www.reallygreatsite.com</Typography>
          <Typography fontSize="11px">📍 123 Anywhere St., Any City</Typography>
        </Stack>

        {/* Language */}
        <SidebarHeader title="LANGUAGE" />
        <Stack spacing={2} sx={{ pl: 1, pr: 2 }}>
          {["Indonesian", "English"].map((lang, idx) => (
            <Box key={lang}>
              <Typography fontSize="11px" fontWeight={500}>{lang}</Typography>
              <Box sx={{ width: "100%", height: "6px", bgcolor: "rgba(255,255,255,0.2)", mt: 0.5, borderRadius: 2 }}>
                <Box sx={{ width: idx === 0 ? "90%" : "70%", height: "100%", bgcolor: accentColor, borderRadius: 2 }} />
              </Box>
            </Box>
          ))}
        </Stack>

        {/* Skills */}
        <SidebarHeader title="SKILLS" />
        <List dense sx={{ p: 0, pl: 1 }}>
          {["Analytical Skills", "Problem Solving", "Adapting to Change", "Time Management", "Good Communication"].map((skill) => (
            <ListItem key={skill} sx={{ px: 0, py: 0.3 }}>
              <ListItemIcon sx={{ minWidth: 20 }}>
                <Box sx={{ width: 6, height: 6, bgcolor: accentColor }} />
              </ListItemIcon>
              <ListItemText 
                primary={<Typography fontSize="11px" sx={{ color: "#fff" }}>{skill}</Typography>} 
              />
            </ListItem>
          ))}
        </List>
      </Box>

      {/* RIGHT MAIN CONTENT */}
      <Box sx={{ width: "62%", p: 6, pt: 8 }}>
        <Box sx={{ mb: 6 }}>
          <Typography variant="h3" sx={{ fontWeight: 900, color: color, lineHeight: 0.8, fontSize: "42px" }}>
            MARCELINE
          </Typography>
          <Typography variant="h3" sx={{ fontWeight: 400, color: color, fontSize: "42px", mb: 1 }}>
            ANDERSON
          </Typography>
          <Typography
            variant="h6"
            sx={{ color: "#444", fontWeight: 500, letterSpacing: 5, fontSize: "16px" }}
          >
            MARKETING
          </Typography>
        </Box>

        <Box sx={{ mb: 5 }}>
          <MainHeader title="PERSONAL PROFILE" />
          <Typography fontSize="12px" color="#555" lineHeight={1.6} sx={{ mt: 1 }}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
          </Typography>
        </Box>

        <Box sx={{ mb: 5 }}>
          <MainHeader title="EDUCATION" />
          <Stack spacing={3} sx={{ mt: 1 }}>
            {[1, 2].map((item) => (
              <Box key={item} sx={{ borderBottom: "1px solid #eee", pb: 2 }}>
                <Typography fontWeight={800} fontSize="13px">Bachelor of Business Management</Typography>
                <Typography fontSize="12px" color={color} fontWeight={600}>Barcelle University</Typography>
                <Typography fontSize="11px" color="#777" sx={{ mt: 0.5 }}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc sit amet sem nec risus egestas accumsan.
                </Typography>
              </Box>
            ))}
          </Stack>
        </Box>

        <Box>
          <MainHeader title="EXPERIENCE" />
          <Stack spacing={3} sx={{ mt: 1 }}>
            <Box>
              <Typography fontSize="12px" fontWeight={900} color={color}>(2020 - 2023)</Typography>
              <Typography fontWeight={800} fontSize="13px" sx={{ textTransform: "uppercase" }}>Senior Graphic Designer</Typography>
              <Typography fontSize="12px" color="#666">Fauget Studio</Typography>
            </Box>
            <Box>
              <Typography fontSize="12px" fontWeight={900} color={color}>(2017 - 2019)</Typography>
              <Typography fontWeight={800} fontSize="13px" sx={{ textTransform: "uppercase" }}>Senior Graphic Designer</Typography>
              <Typography fontSize="12px" color="#666">Larana, Inc</Typography>
            </Box>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
};

export default Resume39;

export const resumeMeta = {
  hasPhoto: true,
  columns: 2,
  colorOptions: [
    { value: "#084c34", label: "Forest Green" },
    { value: "#1a2a6c", label: "Navy Blue" },
    { value: "#b22222", label: "Deep Red" },
    { value: "#2d3436", label: "Graphite" },
  ]
};